import { Routes } from '@angular/router';
import { HomeComponent } from "./pages/home/home.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { TaskListComponent } from "./pages/tasks/task-list/task-list.component";
import { QueryComponent } from "./pages/query/query.component";
import { CorrespondenceComponent } from "./pages/correspondence/correspondence.component";
import { EmailListComponent } from "./pages/correspondence/emails/email-list.component";
import { TemplateListComponent } from "./pages/correspondence/templates/template-list.component";
import { ComposeCorrespondenceComponent } from "./pages/correspondence/compose/compose-correspondence.component";
import { AlertsListComponent } from "./pages/correspondence/alerts/alerts-list.component";
import { TemplateFormComponent } from "./pages/correspondence/templates/template-form.component";
import { TaskDetailComponent } from "./pages/tasks/task-detail/task-detail.component";
import { DistributionsComponent } from "./pages/distributions/distributions.component";
import { DistributionScheduleEditComponent } from "./pages/distributions/distribution-schedule-edit/distribution-schedule-edit.component";
import { DistributionRunsComponent } from "./pages/reports/distribution-runs/distribution-runs.component";
import { ReportsListComponent } from "./pages/reports/reports-list/reports-list.component";
import { ReportDetailComponent } from "./pages/reports/report-detail/report-detail.component";
import {
  SearchCustomerDetailComponent
} from "./pages/search/customer/search-customer-detail/search-customer-detail.component";
import { authenticationGuard } from "./domain/services/auth/authentication.guard";
import { SearchPageComponent } from "./pages/search/search-page/search-page.component";
import { AuthComponent } from "./pages/auth/auth.component";
import { LoginComponent as AuthLoginComponent } from "./pages/auth/components/login/login.component";
import { EmailConfirmationComponent } from "./pages/auth/components/email-confirmation/email-confirmation.component";
import { ChangePasswordComponent } from "./pages/auth/components/change-password/change-password.component";
import {
  RequestPasswordChangeComponent
} from "./pages/auth/components/request-password-change/request-password-change.component";
import {SearchType} from "./domain/enums/search-type.enum";
import {PropertyDetailPageComponent} from "./pages/property/property-detail-page/property-detail-page.component";
import { UsersListComponent } from './pages/users/users-list/users-list.component';
import { UserGroupListComponent } from './pages/user-group/user-group-list/user-group-list.component';
import { PaymentOfficeListComponent } from './pages/payment-office/payment-office-list/payment-office-list.component';
import { SetNewPasswordComponent } from './pages/auth/components/set-new-password/set-new-password.component';
import { ManageUserGroupComponent } from './pages/user-group/manage-user-group/manage-user-group.component';
import { CasheringHomeComponent } from './pages/cashering/cashering-home/cashering-home.component';
import { ReturnDetailComponent } from './pages/cashering/return-detail/return-detail.component';
import { ReceiptComponent } from './pages/cashering/receipt/receipt.component';
import { AdminDistributionsComponent } from './pages/admin/admin-distributions/admin-distributions.component';
import { HolidaysComponent } from './pages/admin/holidays/holidays.component';
import { HolidayFormComponent } from './pages/admin/holidays/holiday-form/holiday-form.component';
import { AppraiserOfficesComponent } from './pages/admin/appraiser-offices/appraiser-offices.component';
import { AppraiserOfficeFormComponent } from './pages/admin/appraiser-offices/appraiser-office-form/appraiser-office-form.component';
import { InterestRatesComponent } from './pages/admin/interest-rates/interest-rates.component';
import { TaxRatesComponent } from './pages/admin/tax-rates/tax-rates.component';
import { JurisdictionsComponent } from './pages/admin/jurisdictions/jurisdictions.component';
import { ExemptionTypesComponent } from './pages/admin/exemption-types/exemption-types.component';
import { FeesComponent } from './pages/admin/fees/fees.component';
import { FeeDetailComponent } from './pages/admin/fees/fee-detail/fee-detail.component';
import { GlobalVariablesComponent } from './pages/admin/global-variables/global-variables.component';
import { ReturnFrequenciesComponent } from './pages/admin/return-frequencies/return-frequencies.component';
import { NotificationTemplatesComponent } from './pages/admin/notification-templates/notification-templates.component';
import { NotificationTemplateFormComponent } from './pages/admin/notification-templates/notification-template-form/notification-template-form.component';
import { PaymentProcessorComponent } from './pages/admin/payment-processor/payment-processor.component';
import { PaymentReportsComponent } from './pages/reports/payment-reports/payment-reports.component';
import { ProfileComponent } from "./pages/profile/profile.component";

export const routes: Routes = [
  {
    path: "app",
    component: HomeComponent,
    canActivate: [authenticationGuard],
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [authenticationGuard]
      },
      {
        path: "query",
        component: QueryComponent
      },
      {
        path: "tasks",
        component: TaskListComponent,
        canActivate: [authenticationGuard],
        data: { moduleName: 'Task' }
      },
      {
        path: "users",
        component: UsersListComponent
      },
      {
        path: "usersGroup",
        component: UserGroupListComponent
      },
       {
        path: "manageUserGroup/:id",
        component: ManageUserGroupComponent
      },  
      {
        path: "paymentOffices",
        component: PaymentOfficeListComponent
      },
      {
        path: "tasks/:id",
        component: TaskDetailComponent,
      },
      {
        path: "search",
        component: SearchPageComponent
      },
      {
        path: "search/customer",
        component: SearchPageComponent,
        data: { searchType: SearchType.CUSTOMER }
      },
      {
        path: "search/customer/:id",
        component: SearchCustomerDetailComponent
      },
      {
        path: "search/property",
        component: SearchPageComponent,
        data: { searchType: SearchType.PROPERTY }
      },
      {
        path: "search/property/:id",
        component: PropertyDetailPageComponent,
      },
      {
        path: "distributions",
        component: DistributionsComponent
      },
      {
        path: "distributions/new",
        component: DistributionScheduleEditComponent
      },
      {
        // Must stay ahead of "distributions/:id" — the router takes the first match, so the
        // wildcard would swallow /distributions/runs as a schedule with the id "runs" and show
        // the schedule editor instead of the runs page.
        path: "distributions/runs",
        component: DistributionRunsComponent
      },
      {
        path: "distributions/:id",
        component: DistributionScheduleEditComponent
      },
      {
        path: "profile",
        component: ProfileComponent
      },
      {
        path: "reports",
        component: ReportsListComponent
      },
      {
        // Old location, from when this page sat under Reports. Kept so existing links and
        // bookmarks still land somewhere.
        path: "reports/distribution-runs",
        redirectTo: "distributions/runs",
        pathMatch: "full"
      },
      {
        path: "reports/payment-reports",
        component: PaymentReportsComponent
      },
      {
        path: "reports/:id",
        component: ReportDetailComponent
      },
      {
        path: "cashering",
        component: CasheringHomeComponent,
        canActivate: [authenticationGuard]
      },
      {
        path: "cashering/drawer/:id",
        loadComponent: () => import('./pages/cashering/drawer-detail/drawer-detail.component').then(m => m.DrawerDetailComponent),
        canActivate: [authenticationGuard]
      },
      {
        path: "cashering/admin-drawers",
        loadComponent: () => import('./pages/cashering/admin-drawers/admin-drawers.component').then(m => m.AdminDrawersComponent),
        canActivate: [authenticationGuard]
      },
      {
        path: "discovery",
        loadComponent: () => import('./pages/discovery/discovery-list.component').then(m => m.DiscoveryListComponent),
        canActivate: [authenticationGuard]
      },
      {
        path: "discovery/map",
        loadComponent: () => import('./pages/discovery/discovery-map.component').then(m => m.DiscoveryMapComponent),
        canActivate: [authenticationGuard]
      },
      {
        path: "discovery/parcels",
        loadComponent: () => import('./pages/discovery/discovery-parcels.component').then(m => m.DiscoveryParcelsComponent),
        canActivate: [authenticationGuard]
      },
      {
        path: "discovery/settings",
        loadComponent: () => import('./pages/discovery/discovery-settings.component').then(m => m.DiscoverySettingsComponent),
        canActivate: [authenticationGuard]
      },
      {
        path: "discovery/:id",
        loadComponent: () => import('./pages/discovery/discovery-detail.component').then(m => m.DiscoveryDetailComponent),
        canActivate: [authenticationGuard]
      },
      {
        path: "cashering/:customerId",
        component: CasheringHomeComponent,
        canActivate: [authenticationGuard]
      },
      {
        path: "cashering/:customerId/return/:returnId",
        component: ReturnDetailComponent,
        canActivate: [authenticationGuard]
      },
      {
        path: "cashering/:customerId/receipt/:receiptId",
        component: ReceiptComponent,
        canActivate: [authenticationGuard]
      },
      {
        path: "correspondence",
        component: CorrespondenceComponent,
        children: [
          { path: "emails", component: EmailListComponent },
          { path: "templates", component: TemplateListComponent },
          { path: "templates/:id", component: TemplateFormComponent },
          { path: "compose", component: ComposeCorrespondenceComponent },
          { path: "alerts", component: AlertsListComponent },
          { path: "", redirectTo: "emails", pathMatch: "full" }
        ]
      },
      {
        path: "admin/distributions",
        component: AdminDistributionsComponent
      },
      {
        path: "admin/holidays",
        component: HolidaysComponent
      },
      {
        path: "admin/holidays/new",
        component: HolidayFormComponent
      },
      {
        path: "admin/holidays/:id",
        component: HolidayFormComponent
      },
      {
        path: "admin/appraiser-offices",
        component: AppraiserOfficesComponent
      },
      {
        path: "admin/appraiser-offices/new",
        component: AppraiserOfficeFormComponent
      },
      {
        path: "admin/appraiser-offices/:id",
        component: AppraiserOfficeFormComponent
      },
      {
        path: "admin/interest-rates",
        component: InterestRatesComponent
      },
      {
        path: "admin/tax-rates",
        component: TaxRatesComponent
      },
      {
        path: "admin/jurisdictions",
        component: JurisdictionsComponent
      },
      {
        path: "admin/exemption-types",
        component: ExemptionTypesComponent
      },
      {
        path: "admin/fees",
        component: FeesComponent,
        data: { feeType: 'Fee' }
      },
      {
        path: "admin/allowances",
        component: FeesComponent,
        data: { feeType: 'Allowance' }
      },
      {
        path: "admin/fees/:id",
        component: FeeDetailComponent
      },
      {
        path: "admin/global-variables",
        component: GlobalVariablesComponent
      },
      {
        path: "admin/return-frequencies",
        component: ReturnFrequenciesComponent
      },
      {
        path: "admin/notification-templates",
        component: NotificationTemplatesComponent
      },
      {
        path: "admin/notification-templates/:code",
        component: NotificationTemplateFormComponent
      },
      {
        path: "admin/payment-processor",
        component: PaymentProcessorComponent
      },
      {
        path: "**",
        redirectTo: "tasks"
      }
    ]
  },
  {
    path: 'login',
    redirectTo: '/auth/login'
  },
    
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      { path: 'login', component: AuthLoginComponent },
      { path: 'request-password-change', component: RequestPasswordChangeComponent },
      { path: 'change-password', component: ChangePasswordComponent },
      { path: 'email-confirmation', component: EmailConfirmationComponent },
      { path: 'create-password', component: SetNewPasswordComponent },
      { path: '**', redirectTo: 'login' }
    ]
  },
  {
    path: '**',
    redirectTo: "/app"
  }
];

